/**
 * Pipeline design tokens — Monday/HubSpot/Linear feel
 * Soft palette, no shouting colors.
 */

export const PAGE_BG = 'bg-[#f5f7fb]'

// Stage başlığı gradient'leri — stage.color hex'inden tona map
export const STAGE_GRADIENTS = {
  violet:  'from-violet-500 to-violet-600',
  indigo:  'from-indigo-500 to-indigo-600',
  sky:     'from-sky-500 to-sky-600',
  blue:    'from-blue-500 to-blue-600',
  cyan:    'from-cyan-500 to-cyan-600',
  teal:    'from-teal-500 to-teal-600',
  emerald: 'from-emerald-500 to-emerald-600',
  amber:   'from-amber-500 to-amber-600',
  orange:  'from-orange-500 to-orange-600',
  pink:    'from-pink-500 to-pink-600',
  rose:    'from-rose-500 to-rose-600',
  slate:   'from-slate-500 to-slate-600',
}

// Hex → token map (en yakın renk)
export function stageGradient(stage) {
  const color = (stage?.color || '').toLowerCase()
  const map = {
    '#5c5cff': 'violet', '#6366f1': 'indigo', '#7c3aed': 'violet', '#8b5cf6': 'violet',
    '#3b82f6': 'blue',   '#2563eb': 'blue',   '#3b9eff': 'sky',
    '#0ea5e9': 'sky',    '#06b6d4': 'cyan',   '#14b8a6': 'teal',
    '#22d3b5': 'teal',   '#10b981': 'emerald','#16a34a': 'emerald',
    '#f59e0b': 'amber',  '#fbbf24': 'amber',  '#f97316': 'orange',
    '#ec4899': 'pink',   '#f472b6': 'pink',   '#ef4444': 'rose',
    '#e11d48': 'rose',   '#6b7280': 'slate',  '#94a3b8': 'slate',
  }
  return STAGE_GRADIENTS[map[color] || 'slate']
}

export const PRIORITY = {
  Critical: { bg: 'bg-red-50',   text: 'text-red-700',   bar: 'bg-red-500',   label: 'Kritik' },
  High:     { bg: 'bg-rose-50',  text: 'text-rose-700',  bar: 'bg-rose-500',  label: 'Yüksek' },
  Medium:   { bg: 'bg-amber-50', text: 'text-amber-700', bar: 'bg-amber-500', label: 'Orta' },
  Low:      { bg: 'bg-sky-50',   text: 'text-sky-700',   bar: 'bg-sky-500',   label: 'Düşük' },
}

// Avatar gradient palette (deterministic by name hash)
export const AVATAR_GRADIENTS = [
  'from-violet-400 to-violet-600',
  'from-sky-400 to-blue-600',
  'from-emerald-400 to-emerald-600',
  'from-pink-400 to-rose-600',
  'from-amber-400 to-orange-600',
  'from-cyan-400 to-teal-600',
  'from-indigo-400 to-indigo-600',
  'from-fuchsia-400 to-pink-600',
]

export function avatarGradient(name) {
  const hash = (name || '').split('').reduce((a, c) => a + c.charCodeAt(0), 0)
  return AVATAR_GRADIENTS[hash % AVATAR_GRADIENTS.length]
}

export function initials(name) {
  if (!name) return '?'
  return name
    .split(/\s+/)
    .filter(Boolean)
    .map((w) => w[0])
    .slice(0, 2)
    .join('')
    .toUpperCase()
}

// Stage probability'sini renge çevir (Won/Lost detection)
export function isWonStage(stage) {
  return stage?.is_won === true || stage?.is_won === 1
}
export function isLostStage(stage) {
  return stage?.is_lost === true || stage?.is_lost === 1
}
